import Vue from 'vue';
import InlineSvg from 'vue-inline-svg';
import InputControl from '@/components/InputControl.vue';
import BrandingLogo from '@/components/BrandingLogo.vue';
import BespokeFooterInformation from '@/components/BespokeFooterInformation.vue';

import {
  getHeaderComponent,
  getFooterComponent,
} from '@/helpers/helpers';

export default (config) => {
  const siteHeader = getHeaderComponent(config);
  const siteFooter = getFooterComponent(config);

  Vue.component('site-header', siteHeader);
  Vue.component('site-footer', siteFooter);

  Vue.component('inline-svg', InlineSvg);
  Vue.component('input-control', InputControl);
  Vue.component('branding-logo', BrandingLogo);
  Vue.component('bespoke-footer-information', BespokeFooterInformation);
};
